import { motion, useScroll, useSpring } from "framer-motion";

export default function ProgressBar() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 120,
        damping: 30,
        mass: 0.4,
    });
    return (
        <motion.div
            className="progress"
            style={{ scaleX }}
            data-testid="scroll-progress"
        />
    );
}
